export var ListOperators;
(function (ListOperators) {
    ListOperators["CONTAINS_ANY_OF_OPERATOR"] = "CONTAINS_ANY_OF";
    ListOperators["CONTAINS_NONE_OF_OPERATOR"] = "CONTAINS_NONE_OF";
    ListOperators["CONTAINS_ALL_OF_OPERATOR"] = "CONTAINS_ALL_OF";
    ListOperators["LIST_OPERATOR_UNSPECIFIED"] = "UNSPECIFIED";
})(ListOperators || (ListOperators = {}));
